const angular = require('angular')
const authCtrl = require('./authCtrl')

module.exports = angular.module('hxphone.verification', ['hxphone.services'])
  .controller('authCtrl', authCtrl)



// WEBPACK FOOTER //
// ./src/js/verification/module.js